import React, { createContext, useContext, useEffect, useState } from 'react';

const DatabaseContext = createContext(null);

export const useDatabase = () => {
  const ctx = useContext(DatabaseContext);
  if (!ctx) throw new Error('useDatabase must be used within DatabaseProvider');
  return ctx;
};

const STORAGE_KEY = 'ac_database_v3';

// Sample seed data for institutions
const SEED_DATA = {
  institutions: [
    {
      id: 'ranchi-uni',
      name: 'Ranchi University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Ranchi, Jharkhand',
      established: '1960',
      website: 'https://ranchiuniversity.ac.in',
      verification_portal: 'https://ranchiuniversity.ac.in/verify',
      status: 'active'
    },
    {
      id: 'skmu',
      name: 'Sido Kanhu Murmu University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Dumka, Jharkhand',
      established: '1992',
      website: 'https://skmu.ac.in',
      verification_portal: 'https://skmu.ac.in/verify',
      status: 'active'
    },
    {
      id: 'bit-mesra',
      name: 'BIT Mesra',
      type: 'Technical Institute',
      classification: 'Deemed University',
      category: 'Private',
      location: 'Ranchi, Jharkhand',
      established: '1955',
      website: 'https://bitmesra.ac.in',
      verification_portal: 'https://bitmesra.ac.in/verify',
      status: 'active'
    },
    {
      id: 'iit-dhanbad',
      name: 'Indian Institute of Technology Dhanbad',
      type: 'Technical Institute',
      classification: 'IIT',
      category: 'Public',
      location: 'Dhanbad, Jharkhand',
      established: '1926',
      website: 'https://iitism.ac.in',
      verification_portal: 'https://iitism.ac.in/verify',
      status: 'active'
    },
    {
      id: 'nit-jamshedpur',
      name: 'National Institute of Technology Jamshedpur',
      type: 'Technical Institute',
      classification: 'NIT',
      category: 'Public',
      location: 'Jamshedpur, Jharkhand',
      established: '1960',
      website: 'https://nitjsr.ac.in',
      verification_portal: 'https://nitjsr.ac.in/verify',
      status: 'active'
    },
    {
      id: 'xavier-ranchi',
      name: 'St. Xavier\'s College Ranchi',
      type: 'College',
      classification: 'Autonomous College',
      category: 'Private',
      location: 'Ranchi, Jharkhand',
      established: '1944',
      website: 'https://sxcran.org',
      verification_portal: 'https://sxcran.org/verify',
      status: 'active'
    },
    {
      id: 'marwari-college',
      name: 'Marwari College Ranchi',
      type: 'College',
      classification: 'Affiliated College',
      category: 'Private',
      location: 'Ranchi, Jharkhand',
      established: '1951',
      website: 'https://marwaricollegeranchi.org',
      verification_portal: 'https://marwaricollegeranchi.org/verify',
      status: 'active'
    },
    {
      id: 'gossner-college',
      name: 'Gossner College Ranchi',
      type: 'College',
      classification: 'Affiliated College',
      category: 'Private',
      location: 'Ranchi, Jharkhand',
      established: '1971',
      website: 'https://gossnercollege.org',
      verification_portal: 'https://gossnercollege.org/verify',
      status: 'active'
    },
    {
      id: 'dav-jamshedpur',
      name: 'DAV College Jamshedpur',
      type: 'College',
      classification: 'Affiliated College',
      category: 'Private',
      location: 'Jamshedpur, Jharkhand',
      established: '1958',
      website: 'https://davjamshedpur.org',
      verification_portal: 'https://davjamshedpur.org/verify',
      status: 'active'
    },
    {
      id: 'vinoba-bhave-uni',
      name: 'Vinoba Bhave University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Hazaribagh, Jharkhand',
      established: '1992',
      website: 'https://vbu.ac.in',
      verification_portal: 'https://vbu.ac.in/verify',
      status: 'active'
    },
    {
      id: 'kolhan-university',
      name: 'Kolhan University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Chaibasa, Jharkhand',
      established: '2009',
      website: 'https://kolhanuniversity.ac.in',
      verification_portal: 'https://kolhanuniversity.ac.in/verify',
      status: 'active'
    },
    {
      id: 'nilamber-pitamber-uni',
      name: 'Nilamber-Pitamber University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Medininagar, Jharkhand',
      established: '2009',
      website: 'https://npuniv.ac.in',
      verification_portal: 'https://npuniv.ac.in/verify',
      status: 'active'
    },
    {
      id: 'jamshedpur-cooperative-college',
      name: 'Jamshedpur Cooperative College',
      type: 'College',
      classification: 'Affiliated College',
      category: 'Private',
      location: 'Jamshedpur, Jharkhand',
      established: '1960',
      website: 'https://jccjamshedpur.org',
      verification_portal: 'https://jccjamshedpur.org/verify',
      status: 'active'
    },
    {
      id: 'karim-city-college',
      name: 'Karim City College Jamshedpur',
      type: 'College',
      classification: 'Affiliated College',
      category: 'Private',
      location: 'Jamshedpur, Jharkhand',
      established: '1956',
      website: 'https://karimcitycollege.org',
      verification_portal: 'https://karimcitycollege.org/verify',
      status: 'active'
    },
    {
      id: 'dumka-medical-college',
      name: 'Dumka Medical College',
      type: 'Medical College',
      classification: 'Government Medical College',
      category: 'Public',
      location: 'Dumka, Jharkhand',
      established: '2019',
      website: 'https://dumkamedicalcollege.org',
      verification_portal: 'https://dumkamedicalcollege.org/verify',
      status: 'active'
    },
    {
      id: 'ranchi-medical-college',
      name: 'Rajendra Institute of Medical Sciences',
      type: 'Medical College',
      classification: 'Government Medical College',
      category: 'Public',
      location: 'Ranchi, Jharkhand',
      established: '2002',
      website: 'https://rimsranchi.org',
      verification_portal: 'https://rimsranchi.org/verify',
      status: 'active'
    },
    {
      id: 'birla-institute-technology',
      name: 'Birla Institute of Technology Patna',
      type: 'Technical Institute',
      classification: 'Deemed University',
      category: 'Private',
      location: 'Patna, Bihar',
      established: '2006',
      website: 'https://bitpatna.ac.in',
      verification_portal: 'https://bitpatna.ac.in/verify',
      status: 'active'
    },
    {
      id: 'patna-university',
      name: 'Patna University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Patna, Bihar',
      established: '1917',
      website: 'https://patnauniversity.ac.in',
      verification_portal: 'https://patnauniversity.ac.in/verify',
      status: 'active'
    },
    {
      id: 'magadh-university',
      name: 'Magadh University',
      type: 'University',
      classification: 'State University',
      category: 'Public',
      location: 'Bodh Gaya, Bihar',
      established: '1962',
      website: 'https://magadhuniversity.ac.in',
      verification_portal: 'https://magadhuniversity.ac.in/verify',
      status: 'active'
    }
  ],
  students: [],
  certificates: [],
  verificationRecords: []
};

export const DatabaseProvider = ({ children }) => {
  const [database, setDatabase] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : SEED_DATA;
    } catch {
      return SEED_DATA;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(database));
    } catch (e) {
      console.warn('Failed to save database:', e);
    }
  }, [database]);

  // One-time migration: normalize hash fields and values
  useEffect(() => {
    try {
      const migrated = { ...database };
      let changed = false;
      if (Array.isArray(migrated.certificates)) {
        migrated.certificates = migrated.certificates.map(c => {
          const existing = (c.fileHash || c.file_hash || '')?.toString();
          const norm = existing ? existing.trim().toLowerCase() : '';
          if (norm && (c.file_hash || c.fileHash !== norm)) {
            changed = true;
            return { ...c, fileHash: norm, ...(c.file_hash ? { file_hash: undefined } : {}) };
          }
          return c;
        });
      }
      if (changed) {
        setDatabase(migrated);
      }
    } catch (e) {
      console.warn('Migration failed:', e);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Institution methods
  const addInstitution = (institution) => {
    const newInst = {
      id: institution.name.toLowerCase().replace(/[^a-z0-9]/g, '-'),
      ...institution,
      createdAt: new Date().toISOString()
    };
    setDatabase(prev => ({
      ...prev,
      institutions: [...prev.institutions, newInst]
    }));
    return newInst;
  };

  const getInstitutions = () => database.institutions;
  
  const getInstitutionById = (id) => database.institutions.find(i => i.id === id);

  // Student methods
  const addStudent = (student) => {
    const newStudent = {
      id: `${student.institutionId}-${student.rollNumber}`,
      ...student,
      createdAt: new Date().toISOString()
    };
    setDatabase(prev => ({
      ...prev,
      students: [...prev.students, newStudent]
    }));
    return newStudent;
  };

  const findStudent = (rollNumber, institutionId) => {
    return database.students.find(s => 
      s.rollNumber === rollNumber && s.institutionId === institutionId
    );
  };

  const getStudentsByInstitution = (institutionId) => {
    return database.students.filter(s => s.institutionId === institutionId);
  };

  // Certificate methods
  const addCertificate = (certificate) => {
    // Normalize hash to lowercase camelCase field
    const normalizedHash = (certificate.fileHash || certificate.file_hash || '')
      ?.toString()
      .trim()
      .toLowerCase();
    const newCert = {
      id: `cert-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      ...certificate,
      ...(normalizedHash ? { fileHash: normalizedHash } : {}),
      uploadedAt: new Date().toISOString()
    };
    setDatabase(prev => ({
      ...prev,
      certificates: [...prev.certificates, newCert]
    }));
    return newCert;
  };

  const getCertificatesByInstitution = (institutionId) => {
    return database.certificates.filter(c => c.institutionId === institutionId);
  };

  const getCertificatesByStudent = (studentId) => {
    return database.certificates.filter(c => c.studentId === studentId);
  };

  const findCertificateByHash = (hash) => {
    const target = (hash || '')?.toString().trim().toLowerCase();
    if (!target) return undefined;
    return database.certificates.find(c => {
      const h = (c.fileHash || c.file_hash || '')?.toString().trim().toLowerCase();
      return !!h && h === target;
    });
  };

  // Verification record methods
  const addVerificationRecord = (record) => {
    const newRecord = {
      id: `verify-${Date.now()}`,
      ...record,
      verifiedAt: new Date().toISOString()
    };
    setDatabase(prev => ({
      ...prev,
      verificationRecords: [...prev.verificationRecords, newRecord]
    }));
    return newRecord;
  };

  const getVerificationsByInstitution = (institutionId) => {
    return database.verificationRecords.filter(v => v.institutionId === institutionId);
  };

  // Analytics methods
  const getAnalytics = () => {
    const institutions = database.institutions.length;
    const students = database.students.length;
    const certificates = database.certificates.length;
    const verifications = database.verificationRecords.length;

    const institutionStats = database.institutions.map(inst => ({
      ...inst,
      studentCount: database.students.filter(s => s.institutionId === inst.id).length,
      certificateCount: database.certificates.filter(c => c.institutionId === inst.id).length,
      verificationCount: database.verificationRecords.filter(v => v.institutionId === inst.id).length
    }));

    return {
      summary: { institutions, students, certificates, verifications },
      institutionStats,
      recentActivity: [
        ...database.certificates.slice(-10).map(c => ({ type: 'certificate', ...c })),
        ...database.verificationRecords.slice(-10).map(v => ({ type: 'verification', ...v }))
      ].sort((a, b) => new Date(b.uploadedAt || b.verifiedAt) - new Date(a.uploadedAt || a.verifiedAt))
    };
  };

  // Bulk import methods
  const importStudents = (students, institutionId) => {
    const newStudents = students.map(student => ({
      id: `${institutionId}-${student.rollNumber}`,
      institutionId,
      ...student,
      createdAt: new Date().toISOString()
    }));
    
    setDatabase(prev => ({
      ...prev,
      students: [...prev.students, ...newStudents]
    }));
    return newStudents;
  };

  const exportDatabase = () => {
    return database;
  };

  const importDatabase = (data) => {
    setDatabase({ ...SEED_DATA, ...data });
  };

  const resetDatabase = () => {
    localStorage.removeItem(STORAGE_KEY);
    setDatabase(SEED_DATA);
  };

  const value = {
    database,
    // Institution methods
    addInstitution,
    getInstitutions,
    getInstitutionById,
    // Student methods
    addStudent,
    findStudent,
    getStudentsByInstitution,
    importStudents,
    // Certificate methods
    addCertificate,
    getCertificatesByInstitution,
    getCertificatesByStudent,
    findCertificateByHash,
    // Verification methods
    addVerificationRecord,
    getVerificationsByInstitution,
    // Analytics
    getAnalytics,
    // Import/Export
    exportDatabase,
    importDatabase,
    resetDatabase
  };

  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
};

export default DatabaseContext;
